module.exports = __webpack_public_path__ + "static/img/management-hub.71de52b.png";


//////////////////
// WEBPACK FOOTER
// ./LandingPageTemp/Assets/management-hub.png
// module id = plKf
// module chunks = 1